export default "__VITE_ASSET__CHxO3wBy__"